import { Component, inject, signal } from '@angular/core';

import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { SharedModule } from '@app/shared/shared.module';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ParagraphComponent } from '@app/shared/components/text/p/p.component';

@Component({
  selector: 'slotcom-info-casino-modal',
  templateUrl: './info-casino.component.html',
  styleUrls: ['./info-casino.component.scss'],
  standalone: true,
  imports: [SharedModule, ParagraphComponent],
})
export class InfoCasinoComponent {
  private eventManager = inject(EventManager);

  casinoInfoModalData = signal(inject<Modal>(MAT_DIALOG_DATA));

  readonly steps = [
    { asset: 'step-1', label: 'home.progress-line.casino-info.step-1' },
    { asset: 'step-2', label: 'home.progress-line.casino-info.step-2' },
    { asset: 'step-3', label: 'home.progress-line.casino-info.step-3' },
  ];

  closeInfo() {
    this.eventManager.closeModal(new Modal(this.casinoInfoModalData().id, ModalType.View));
  }
}
